
import {
  Vue,
  Component,
  Prop,
  ModelSync,
  Inject
} from "vue-property-decorator";
import { Control, OxygenControlsTreeContext } from "@/oxygen/classes/lib/types";
import AlignGrid from "@/oxygen/classes/inputs/align/AlignGrid.vue";
import { AlignInputValue } from "@/oxygen/classes/lib/align";
import lodash from "lodash";
import { uiStore } from "@/store/store-accessor";

@Component({
  components: {
    AlignGrid
  }
})
export default class OxygenAlignInput extends Vue {
  @Prop()
  control!: Control;

  @Prop()
  path!: string;

  @ModelSync("value", "input", {
    default: () => ({})
  })
  syncedValue!: AlignInputValue;

  @Inject({ from: "oxyContext" })
  readonly context!: OxygenControlsTreeContext;

  beforeCreate() {
    // @ts-ignore
    this.$options.components.OxygenControl =
      require("@/oxygen/classes/OxygenControl.vue").default;
  }

  verticalAlignment = [
    { value: "start", label: "Left" },
    { value: "center", label: "Center" },
    { value: "end", label: "Right" }
  ];

  horizontalAlignment = [
    { value: "start", label: "Top" },
    { value: "center", label: "Center" },
    { value: "end", label: "Bottom" }
  ];

  positionAlignment = [
    { value: "stretch", label: "Stretch" },
    { value: "baseline", label: "Baseline" }
  ];

  distributionAlignment = [
    { value: "space-between", label: "Space Between" },
    { value: "space-around", label: "Space Around" }
  ];

  get layout() {
    return this.context.getParentControlValueAt(this.path, this.breakpoint) as {
      display: string;
      flex_direction: string;
    };
  }

  get breakpoint() {
    return uiStore.currentBreakpoint.id;
  }

  get display() {
    return this.layout?.display || "flex";
  }

  get direction() {
    if (this.display === "grid") {
      return "column";
    }

    return this.layout?.flex_direction || "row";
  }

  get isFlexRow() {
    return this.display === "flex" && ["row", "wrap"].includes(this.direction);
  }

  get primaryControl(): Control {
    const items = this.isFlexRow
      ? [...this.verticalAlignment, ...this.distributionAlignment]
      : [...this.verticalAlignment, ...this.positionAlignment];

    return {
      slug: "primary_axis",
      name: "X",
      type: "select",
      items
    };
  }

  get crossControl(): Control {
    const items =
      this.isFlexRow || this.display === "grid"
        ? [...this.horizontalAlignment, ...this.positionAlignment]
        : [...this.horizontalAlignment, ...this.distributionAlignment];

    return {
      slug: "cross_axis",
      name: "Y",
      type: "select",
      items
    };
  }

  updateInnerValue(path: string, value: string) {
    this.syncedValue = lodash.set(this.syncedValue, path, value);
  }
}
